export default "__VITE_ASSET__ZyS9bxi___"